import React from 'react';

const PolicyRunIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <path d="M24 6V0H0v6h1v14h3v2h20v-6H4v2H3v-6h1v2h20V8H4v2H3V6zM6 18h16v2H6zm0-8h16v2H6zM2 4V2h20v2z"/>
        </svg>)
};

export default PolicyRunIcon;